var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { DeSerializationService, DeService, } from '@synisys/idm-de-service-client-js';
import { FormService, FormType, } from '@synisys/idm-dynamic-layout-interpreter';
import { KbService, MetaFieldType, } from '@synisys/idm-kb-service-client-js';
import { ValidationService, } from '@synisys/idm-validation-calculation-service-client-js';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { noop } from 'rxjs/util/noop';
import { DynamicLayoutType } from '../../component/dynamic-layout';
import { PopupSubFormComponent, } from '../../component/popup/popup-sub-form.component';
import { ActionBuilder, ContextArg, ContextArgEnum, FieldArg, } from '../layout-actions';
import { ActionNotifierKey } from '../../concepts/action-notifier-key.enum';
import { ActionNotificationData } from '../../concepts/action-notification-data.model';
var DynamicFormPopupsService = /** @class */ (function () {
    function DynamicFormPopupsService(validationService, deSerializationService, deService, formService, kbService) {
        this.validationService = validationService;
        this.deSerializationService = deSerializationService;
        this.deService = deService;
        this.formService = formService;
        this.kbService = kbService;
    }
    DynamicFormPopupsService.prototype.openEditPopup = function (form, categoryName, subFormKey, subEntity, formId) {
        form.popupEditMode = true;
        this.openPopupAction(form, categoryName, subFormKey, subEntity, formId);
    };
    DynamicFormPopupsService.prototype.openPopup = function (form, categoryName, subFormKey, subEntity, formId) {
        var _this = this;
        form.popupEditMode = false;
        if (subEntity) {
            this.openPopupAction(form, categoryName, subFormKey, subEntity, formId);
        }
        else {
            this.deService
                .createBlankSubEntity(categoryName)
                .subscribe(function (_subEntity) {
                _this.openPopupAction(form, categoryName, subFormKey, _subEntity, formId);
            }, console.error);
        }
    };
    DynamicFormPopupsService.prototype.addSubEntity = function (form, item, fieldSystemName, close) {
        var _this = this;
        var validationService = this.validationService;
        var categoryName = form.metaForm.layoutModel.category;
        var entity = form.entity;
        var activePopup = form.activePopup;
        var validations = [];
        this.cloneEntityAndDeserializeOnAdd(form, item, fieldSystemName).subscribe(function (serialized) {
            validationService
                .calculateAndValidateField(categoryName, fieldSystemName, serialized, _this.getWorkflowStateId(form))
                .subscribe(function (valCalcData) {
                if (valCalcData.getValidations().length > 0) {
                    valCalcData.getValidations().map(function (validation) {
                        for (var _i = 0, _a = validation.getRelatedMetaFieldIds(); _i < _a.length; _i++) {
                            var relatedFieldSystemName = _a[_i];
                            if (relatedFieldSystemName.getSystemName() !==
                                fieldSystemName) {
                                validations.push(validation);
                            }
                            else {
                                activePopup.popupValidationMessage = validation.getMessage();
                            }
                        }
                    });
                }
                else {
                    _this.deSerializationService
                        .deserializeMainEntity(categoryName, Observable.of(valCalcData.getData()))
                        .subscribe(function (newEntity) {
                        var oldSubEntityList = form.entity.getProperty(fieldSystemName).value || [];
                        var oldSubEntityIds = new Set(oldSubEntityList.map(function (oldListItem) { return oldListItem.getId(); }));
                        var newSubEntityList = newEntity.getProperty(fieldSystemName).value || [];
                        var newSubEntity = newSubEntityList.find(function (newListItem) { return !oldSubEntityIds.has(newListItem.getId()); });
                        form.entity.getProperty(fieldSystemName).value = newEntity.getProperty(fieldSystemName).value;
                        form.actionNotifier.next(new ActionNotificationData(ActionNotifierKey.SUB_FORM_SAVE_ACTION, newSubEntity));
                    }, console.error);
                    if (close) {
                        activePopup.close();
                    }
                    validations.length = 0;
                }
                form.setPopupValidations(validations);
            }, console.error);
        }, console.error);
    };
    DynamicFormPopupsService.prototype.editSubEntity = function (form, item, fieldSystemName, close) {
        var _this = this;
        var validationService = this.validationService;
        var categoryName = form.metaForm.layoutModel.category;
        var entity = form.entity;
        var activePopup = form.activePopup;
        var validations = [];
        this.cloneEntityAndDeserializeOnEdit(form, item, fieldSystemName).subscribe(function (serialized) {
            validationService
                .calculateAndValidateField(categoryName, fieldSystemName, serialized, _this.getWorkflowStateId(form))
                .subscribe(function (valCalcData) {
                if (valCalcData.getValidations().length > 0) {
                    valCalcData.getValidations().map(function (validation) {
                        for (var _i = 0, _a = validation.getRelatedMetaFieldIds(); _i < _a.length; _i++) {
                            var relatedFieldSystemName = _a[_i];
                            if (relatedFieldSystemName.getSystemName() !==
                                fieldSystemName) {
                                validations.push(validation);
                            }
                            else {
                                activePopup.popupValidationMessage = validation.getMessage();
                            }
                        }
                    });
                }
                else {
                    _this.deSerializationService
                        .deserializeMainEntity(categoryName, Observable.of(valCalcData.getData()))
                        .subscribe(function (newEntity) {
                        var newSubEntityList = newEntity.getProperty(fieldSystemName).value || [];
                        var editedSubEntity = newSubEntityList.find(function (newListItem) {
                            return newListItem.getId() === item.getId();
                        });
                        form.entity.getProperty(fieldSystemName).value = newEntity.getProperty(fieldSystemName).value;
                        form.actionNotifier.next(new ActionNotificationData(ActionNotifierKey.SUB_FORM_SAVE_ACTION, editedSubEntity));
                    }, console.error);
                    if (close) {
                        form.activePopup.close();
                    }
                    validations.length = 0;
                }
                form.setPopupValidations(validations);
            }, console.error);
        }, console.error);
    };
    DynamicFormPopupsService.prototype.onCancelPopup = function (form, popupFieldCategory, popupFieldName) {
        var _this = this;
        if (form.metaForm.formType === FormType.VIEW) {
            form.activePopup.close();
            return;
        }
        this.kbService
            .getMetaFields(popupFieldCategory)
            .pipe(map(function (metaFields) {
            if (!form.entity.getId()) {
                _this.clearEntity(form.activePopup.entity, metaFields);
            }
            else {
                // reset from old entity
                var popupOldEntity = form.oldEntity
                    .getProperty(popupFieldName)
                    .value.find(function (entity) {
                    return entity.getId() ===
                        form.activePopup.entity.getId();
                });
                if (popupOldEntity) {
                    _this.restoreEntityFromOld(form.activePopup.entity, popupOldEntity, metaFields);
                }
                else {
                    _this.clearEntity(form.activePopup.entity, metaFields);
                }
            }
            form.activePopup.close();
            form.actionNotifier.next(new ActionNotificationData(ActionNotifierKey.SUB_FORM_CLOSE_ACTION, undefined));
        }))
            .subscribe(noop, console.error);
    };
    DynamicFormPopupsService.prototype.getActions = function () {
        var _this = this;
        var result = [];
        result.push(new ActionBuilder()
            .name('openEditPopup')
            .action(function (form, categoryName, subFormKey, subEntity, formId) {
            return _this.openEditPopup(form, categoryName, subFormKey, subEntity, formId);
        })
            .build());
        result.push(new ActionBuilder()
            .name('openPopup')
            .action(function (form, categoryName, subFormKey, subEntity, formId) {
            return _this.openPopup(form, categoryName, subFormKey, subEntity, formId);
        })
            .build());
        result.push(new ActionBuilder()
            .name('addSubEntity')
            .action(function (form, item, fieldSystemName, close) { return _this.addSubEntity(form, item, fieldSystemName, close); })
            .build());
        result.push(new ActionBuilder()
            .name('editSubEntity')
            .action(function (form, item, fieldSystemName, close) { return _this.editSubEntity(form, item, fieldSystemName, close); })
            .build());
        result.push(new ActionBuilder()
            .name('onCancelPopup')
            .params([
            ContextArg(ContextArgEnum.FORM),
            FieldArg('field-category'),
            FieldArg('field-name'),
        ])
            .action(function (form, popupFieldCategory, popupFieldName) {
            return _this.onCancelPopup(form, popupFieldCategory, popupFieldName);
        })
            .build());
        return result;
    };
    DynamicFormPopupsService.prototype.openPopupAction = function (dynamicForm, categoryName, subFormKey, subEntity, formId) {
        this.formService
            .loadForm(subFormKey, formId, categoryName)
            .subscribe(function (formData) {
            var popupProperties = formData.model.content.properties.generalProperties.get('popup_properties');
            var width = popupProperties['width'];
            // const height: string = popupProperties['height'];
            var title = popupProperties['titleString'];
            var dialogRef = dynamicForm.dialog.open(PopupSubFormComponent, {
                disableClose: dynamicForm.metaForm.formType === FormType.EDIT,
                // height: height,
                width: width,
                data: {
                    form: dynamicForm,
                    formId: formId,
                    formKey: subFormKey,
                    entity: subEntity,
                    categoryName: categoryName,
                    title: title,
                    layoutType: DynamicLayoutType.subForm,
                },
            });
            dynamicForm.activePopup = dialogRef.componentInstance;
        }, console.error);
    };
    DynamicFormPopupsService.prototype.getWorkflowStateId = function (form) {
        var wfStateMetaField = form.metaForm.wfStateMetaField;
        if (wfStateMetaField) {
            return form.entity.getProperty(wfStateMetaField.getSystemName()).value
                ? form.entity
                    .getProperty(wfStateMetaField.getSystemName())
                    .value.getId()
                : undefined;
        }
        return undefined;
    };
    DynamicFormPopupsService.prototype.cloneEntityAndDeserializeOnEdit = function (form, item, fieldSystemName) {
        var entity = form.entity;
        var categoryName = form.metaForm.layoutModel.category;
        var withEditedSubformEntity = entity.clone();
        var subEntityIndex = withEditedSubformEntity
            .getProperty(fieldSystemName)
            .value.findIndex(function (sub) { return sub.getId() === item.getId(); });
        withEditedSubformEntity.getProperty(fieldSystemName).value[subEntityIndex] = item;
        return this.deSerializationService.serializeEntity(categoryName, withEditedSubformEntity);
    };
    DynamicFormPopupsService.prototype.cloneEntityAndDeserializeOnAdd = function (form, item, fieldSystemName) {
        var entity = form.entity;
        var categoryName = form.metaForm.layoutModel.category;
        var withNewSubformEntity = entity.clone();
        withNewSubformEntity
            .getProperty(fieldSystemName)
            .value.push(item);
        return this.deSerializationService.serializeEntity(categoryName, withNewSubformEntity);
    };
    DynamicFormPopupsService.prototype.clearEntity = function (entity, metaFields) {
        if (!entity) {
            return;
        }
        metaFields.forEach(function (metaField) {
            var fieldType = metaField.getType();
            entity.getProperty(metaField.getSystemName()).value =
                // array type fields
                fieldType === MetaFieldType.MULTI_SELECT ||
                    fieldType === MetaFieldType.SUB_ENTITY
                    ? []
                    : // value setter doesn't accept undefined
                        null;
        });
    };
    DynamicFormPopupsService.prototype.restoreEntityFromOld = function (entity, oldEntity, metaFields) {
        if (!entity) {
            return;
        }
        metaFields.forEach(function (metaField) {
            var fieldName = metaField.getSystemName();
            entity.getProperty(fieldName).value = oldEntity.getProperty(fieldName).value;
        });
    };
    DynamicFormPopupsService = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [ValidationService,
            DeSerializationService,
            DeService,
            FormService,
            KbService])
    ], DynamicFormPopupsService);
    return DynamicFormPopupsService;
}());
export { DynamicFormPopupsService };
//# sourceMappingURL=dynamic-form-popups.service.js.map